import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';
import { MatButtonModule } from '@angular/material/button';
import { PipesModule } from '@shared/pipes/pipes.module';
import { HintModule } from '@shared/modules/hint/hint.module';
import { ButtonModule } from '@shared/modules/form-components/button/button.module';
import { TextFieldLabelComponent } from '@shared/modules/form-components/text-field-label/text-field-label.component';
import { DatepickerComponent } from '@shared/modules/form-components/datepicker/datepicker.component';
import { FormFieldComponent } from '@shared/modules/form-components/form-field/form-field.component';
import { TagsAutocompleteComponent } from '@shared/modules/form-components/tags-autocomplete/tags-autocomplete.component';
import { InlineSVGModule } from 'ng-inline-svg';
import { SpokenLanguageSelectionComponent } from '@shared/modules/form-components/spoken-language-selection/spoken-language-selection.component';
import { QuillModule } from 'ngx-quill';
import { CheckboxComponent } from '@shared/modules/form-components/checkbox/checkbox.component';
import { UiSwitchModule } from 'ngx-ui-switch';
import { SwitchComponent } from '@shared/modules/form-components/switch/switch.component';
import { DirectivesModule } from '@shared/directives/directives.module';
import { TextFieldComponent } from '@shared/modules/form-components/text-field/text-field.component';
import { RadioGroupComponent } from './radio-group/radio-group.component';
import { SelectComponent } from './select/select.component';
import { FormHeaderComponent } from './form-header/form-header.component';
import { AddTagOptionTemplateComponent } from './select/templates/add-tag-option-template/add-tag-option-template.component';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { TextAreaComponent } from './text-area/text-area.component';
import { YesNoSelectComponent } from './yes-no-select/yes-no-select.component';
import { TagComponent } from './tag/tag.component';
import { TextEditorComponent } from './text-editor/text-editor.component';
import { StartEndDatePickerComponent } from './start-end-date-picker/start-end-date-picker.component';
import { PhotoUploadComponent } from '@shared/modules/form-components/photo-upload/photo-upload.component';
import { TippyModule } from '@ngneat/helipopper';

@NgModule({
  declarations: [
    SelectComponent,
    RadioGroupComponent,
    FormHeaderComponent,
    FormFieldComponent,
    TextFieldLabelComponent,
    DatepickerComponent,
    AddTagOptionTemplateComponent,
    FileUploadComponent,
    TextAreaComponent,
    YesNoSelectComponent,
    TagsAutocompleteComponent,
    TagComponent,
    SpokenLanguageSelectionComponent,
    TextEditorComponent,
    StartEndDatePickerComponent,
    CheckboxComponent,
    SwitchComponent,
    TextFieldComponent,
    PhotoUploadComponent,
  ],
  imports: [
    CommonModule,
    MatInputModule,
    MatSelectModule,
    MatDatepickerModule,
    UiSwitchModule,
    TranslateModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    MatCheckboxModule,
    MatRadioModule,
    MatButtonModule,
    PipesModule,
    HintModule,
    ButtonModule,
    InlineSVGModule,
    QuillModule,
    DirectivesModule,
    TippyModule,
  ],
  exports: [
    SelectComponent,
    RadioGroupComponent,
    FormHeaderComponent,
    FormFieldComponent,
    TextFieldLabelComponent,
    DatepickerComponent,
    AddTagOptionTemplateComponent,
    FileUploadComponent,
    TextAreaComponent,
    YesNoSelectComponent,
    TagsAutocompleteComponent,
    SpokenLanguageSelectionComponent,
    TextEditorComponent,
    StartEndDatePickerComponent,
    CheckboxComponent,
    SwitchComponent,
    TextFieldComponent,
    PhotoUploadComponent,
    TagComponent,
  ],
})
export class FormComponentsModule {}
